/**
 * Store du state live de l'artefact "gathering" — cloisonné par conversation.
 *
 * Voir `convScopedStore.ts` pour la mécanique. Un event d'une autre conv
 * n'écrase jamais la conv courante (les handlers mutent via
 * `getGatheringStateForConv(payload.conversation_id)`).
 */

import { createConvScopedStore } from '@ggvie-consulting/lib/convScopedStore'
import type { FieldSnapshot } from '@ggvie-consulting/types/gathering'

export interface GatheringArtifactState {
  active: boolean
  gathering_id: string | null
  conversation_id: string | null
  purpose: string | null
  target_component_type: string | null
  fields: FieldSnapshot[]
  /** SD-3875 — texte de la question pendante (utilisé au refresh pour rappeler
   *  au user la question à laquelle on attend une réponse). Vide hors refresh
   *  car les questions arrivent normalement via le stream de messages. */
  last_question: string
}

const store = createConvScopedStore<GatheringArtifactState>((convId) => ({
  active: false,
  gathering_id: null,
  conversation_id: convId || null,
  purpose: null,
  target_component_type: null,
  fields: [],
  last_question: '',
}))

export const gatheringArtifactState = store.currentState
export const setCurrentConversation = store.setCurrentConversation
export const getGatheringStateForConv = store.getStateForConv
export const resetGatheringStateForConv = store.resetStateForConv
export const resetAllGatheringStates = store.resetAll

// Pas de `import.meta.hot.accept()` : ce store porte un state runtime (Map des
// states par conv). Un HMR accept tuerait silencieusement le state en cours.
// On laisse Vite full-reload le module si nécessaire.
